function useEmployeePerformanceTraining() {
  return {};
}

export default useEmployeePerformanceTraining;
